import React from "react";
import * as c from "./lpOneColSection.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import { processMarkdown } from "@utils/markdown";
import { ContentfulCta } from "@components/shared/cta";
import WistiaVideoPopover from "@components/wistia/wistiaVideoPopover";
import IconPlay from "@components/icons/iconPlay";

export default function LpOneColSection({
  label,
  heading,
  subheading,
  sectionId,
  wistiaVideoId = null,
  desktopImage,
  mobileImage,
  ctas = [],
}) {
  const subheadingHtml = processMarkdown(subheading?.subheading);
  const shouldRenderCtas = ctas && ctas.length > 0;
  const shouldRenderTextContainer = [label, heading, subheading, shouldRenderCtas].some(Boolean);
  const ctaHasButtonStyle = ({ style }) => ["Button Primary", "Button Secondary"].some((s) => style.includes(s));

  return (
    <section id={sectionId} className={c.container}>
      {shouldRenderTextContainer && (
        <div className={c.textContainer} data-transition="slide-enter-child">
          {label && <p className={classNames(c.eyebrow, "eyebrow")}>{label}</p>}
          {heading && <h2 className={classNames(c.heading, "h2")}>{heading}</h2>}
          {subheadingHtml && (
            <div className={classNames(c.subheading, "p2")} dangerouslySetInnerHTML={{ __html: subheadingHtml }} />
          )}

          {shouldRenderCtas && (
            <div className={c.ctaContainer}>
              {ctas.map((cta) => (
                <ContentfulCta key={cta.id} {...cta} size={ctaHasButtonStyle(cta) ? "large" : "medium"} />
              ))}
            </div>
          )}
        </div>
      )}

      {desktopImage && (
        <div
          className={classNames(c.imageContainer, { [c.usesMobileImage]: mobileImage })}
          data-transition="slide-enter"
        >
          {wistiaVideoId && (
            <div className={c.wistiaWrapper}>
              <WistiaVideoPopover className={c.wistia} wistiaVideoId={wistiaVideoId}>
                <IconPlay className={c.playButton} />
              </WistiaVideoPopover>
            </div>
          )}
          <GatsbyImage image={getImage(desktopImage)} className={c.desktopImage} alt={label} />
          {mobileImage && (
            <GatsbyImage image={getImage(mobileImage)} className={c.mobileImage} alt={`${label} mobile`} />
          )}
        </div>
      )}
    </section>
  );
}
